import { parseResponseError } from '../../../../common/helpers';
import { DatasourceReturnType, ResponseError } from '../../../../models';
import { SuperAdminRequest, SuperAdminResponse } from '../schemas';
import { getAll, updateSuperAdminConfig } from '../datasources/superAdmin.datasource';

export async function getSuperAdmin(
): Promise<DatasourceReturnType<ResponseError, SuperAdminResponse>> {
    try {
        const data = (await getAll()).data;

        return [null!, data];
    } catch (error) {
        const reason = parseResponseError(error);

        if (reason) {
            return [reason, null!];
        }

        throw error;
    }
}

export async function updateSuperAdmin(
    body: SuperAdminRequest
): Promise<DatasourceReturnType<ResponseError, SuperAdminResponse>> {
    try {
        const data = (await updateSuperAdminConfig(body)).data;

        return [null!, data];
    } catch (error) {
        const reason = parseResponseError(error);

        if (reason) {
            return [reason, null!];
        }

        throw error;
    }
}
